import IndexLinks from "../IndexLinks"

const HelpTopicGestionCompetIndex = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Gestion de votre compétition', link: '/topics/gestion-compet'},
  ]

  const links = [
    { title: "Général", link: '/topics/gestion-compet/general'},
    { title: "Volontaires et co-organisateurs", link: '/topics/gestion-compet/general'},
    { title: "Paiements et versements", link: '/topics/gestion-compet/versements'},
    { title: "Exporter les données", link: '/topics/gestion-compet/data'},
  ]

  return <IndexLinks goBackLinks={goBackLinks} links={links}/>
}

export default HelpTopicGestionCompetIndex